<template>
  <div>
    <label class="text-xs text-typo font-weight-bolder ms-1"
      >GESTION DES CLIENTS</label
    >
    <v-autocomplete
      v-model="selectedClient"
      :items="clientList"
      item-text="displayname"
      return-object
      color="rgba(0,0,0,.6)"
      class="
        input-style
        font-size-input
        text-light-input
        placeholder-light
        border-radius-md
        select-style
        mb-0
      "
      outlined
      single-line
      height="26"
    >
    </v-autocomplete>
  </div>
</template>

<script>
export default {
  name: "ClientSelector",

  computed: {
    clientList() {
      return this.$store.getters.clientsSorted;
    },
    selectedClient: {
      get() {
        return this.$store.getters.selectedClient;
      },
      set(value) {
        this.$store.dispatch("set_selected_client", value);
      },
    },
  },

  watch: {
    // -- Select the first item if selectedClient is null
    clientList(nVal) {
      if (nVal.length > 0 && this.selectedClient === null) {
        this.selectedClient = nVal[0];
      }
    },
  },
};
</script>

<style scoped></style>
